declare module '@coorpacademy/nova-icons';
declare module '@coorpacademy/react-native-slider';
declare module '@react-native-community/blur';
declare module '@coorpacademy/translate';
declare module 'browser-env';
declare module 'react-native/*';
declare module 'css-color-function';
declare module 'classnames';
declare module '*.css';
